module.exports = (() => {
    const CANARY = "rc";
const getCookie = name => {
  const cookie = document.cookie.split(';').find(c => c.trim().startsWith(`${name}=`));
  return cookie ? cookie.split('=').pop() : null;
};
const getVersion = () => {
  const name = window['_canary'] || getCookie('_canary');
  return name === 'true' ? CANARY : '';
};
const getRemote = (name, url, entry, def = false) => {
  return new Promise(resolve => {
    const script = document.createElement('script');
    script.src = [url, def ? '' : getVersion(), entry].filter(Boolean).join('/');

    script.onload = ev => {
      const proxy = {
        get: request => window[name].get(request),
        init: arg => {
          try {
            return window[name].init(arg);
          } catch (e) {
            console.log(`Remote container ${name} already initialized`);
          }
        }
      };

      resolve(proxy);
    };

    if (!def)
      script.onerror = () => {
        script.remove();
        getRemote(name, url, entry, true).then(resolve);
      };

    document.head.appendChild(script);
  });
};;
    return getRemote('FinancialPlanning', 'https://builders.metrocuadrado.com/ptec-builders-frontend-financial-planning-mf', 'remoteEntry.js?1.0.7')
  })();